import {
  createNews,
  deleteNews,
  editNews,
  getNews,
  getFeaturedNews,
  getNewsById,
  toggleNewsStatus,
  getNewsDetails,
  updateNewsDetails,
  createNewsDetails,
  getNewsPublicDetails,
} from "./asyncThunks";

// Postojeći builders
export const getNewsBuilder = (builder) => {
  builder.addCase(getNews.pending, (state) => {
    state.news.loading = true;
    state.news.error = null;
  });
  builder.addCase(getNews.fulfilled, (state, { payload }) => {
    const { data, total, page, perPage, maxReached } = payload;
    state.news.data = data;
    state.news.total = total;
    state.news.page = page;
    state.news.perPage = perPage;
    state.news.maxReached = maxReached;
    state.news.loading = false;
  });
  builder.addCase(getNews.rejected, (state, action) => {
    state.news.loading = false;
    state.news.error = action.error.message;
  });
};

export const getFeaturedNewsBuilder = (builder) => {
  builder.addCase(getFeaturedNews.pending, (state) => {
    state.featuredNews.loading = true;
    state.featuredNews.error = null;
  });
  builder.addCase(getFeaturedNews.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.featuredNews.data = data;
    state.featuredNews.loading = false;
  });
  builder.addCase(getFeaturedNews.rejected, (state, action) => {
    state.featuredNews.loading = false;
    state.featuredNews.error = action.error.message;
  });
};

export const getNewsByIdBuilder = (builder) => {
  builder.addCase(getNewsById.pending, (state) => {
    state.newsById.loading = true;
    state.newsById.error = null;
  });
  builder.addCase(getNewsById.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.newsById.data = data;
    state.newsById.loading = false;
  });
  builder.addCase(getNewsById.rejected, (state, action) => {
    state.newsById.loading = false;
    state.newsById.error = action.error.message;
  });
};

export const createNewsBuilder = (builder) => {
  builder.addCase(createNews.pending, (state) => {
    state.news.createLoading = true;
    state.news.error = null;
  });
  builder.addCase(createNews.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.news.data = [...state.news.data, data];
    state.news.createLoading = false;
  });
  builder.addCase(createNews.rejected, (state, action) => {
    state.news.createLoading = false;
    state.news.error = action.error.message;
  });
};

export const deleteNewsBuilder = (builder) => {
  builder.addCase(deleteNews.pending, (state) => {
    state.news.deleteLoading = true;
    state.news.error = null;
  });
  builder.addCase(deleteNews.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.news.data = state.news.data.filter((n) => n.id !== data.id);
    state.news.deleteLoading = false;
  });
  builder.addCase(deleteNews.rejected, (state, action) => {
    state.news.deleteLoading = false;
    state.news.error = action.error.message;
  });
};

export const toggleNewsStatusBuilder = (builder) => {
  builder.addCase(toggleNewsStatus.pending, (state) => {
    state.news.toggleLoading = true;
    state.news.error = null;
  });
  builder.addCase(toggleNewsStatus.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.news.data = state.news.data.map((n) => (n.id === data.id ? data : n));
    state.news.toggleLoading = false;
  });
  builder.addCase(toggleNewsStatus.rejected, (state, action) => {
    state.news.toggleLoading = false;
    state.news.error = action.error.message;
  });
};

export const editNewsBuilder = (builder) => {
  builder.addCase(editNews.pending, (state) => {
    state.news.editLoading = true;
    state.news.error = null;
  });
  builder.addCase(editNews.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.news.data = state.news.data.map((n) => (n.id === data.id ? data : n));
    state.news.editLoading = false;
  });
  builder.addCase(editNews.rejected, (state, action) => {
    state.news.editLoading = false;
    state.news.error = action.error.message;
  });
};

// NOVI BUILDERS ZA DETAILS
export const getNewsDetailsBuilder = (builder) => {
  builder.addCase(getNewsDetails.pending, (state) => {
    state.newsDetails.loading = true;
    state.newsDetails.error = null;
  });
  builder.addCase(getNewsDetails.fulfilled, (state, { payload }) => {
    state.newsDetails.data = payload.data || payload;
    state.newsDetails.loading = false;
  });
  builder.addCase(getNewsDetails.rejected, (state, action) => {
    state.newsDetails.loading = false;
    state.newsDetails.error = action.payload || action.error.message;
  });
};

export const updateNewsDetailsBuilder = (builder) => {
  builder.addCase(updateNewsDetails.pending, (state) => {
    state.newsDetails.updateLoading = true;
    state.newsDetails.error = null;
  });
  builder.addCase(updateNewsDetails.fulfilled, (state, { payload }) => {
    const updatedData = payload.data || payload;
    state.newsDetails.data = updatedData;
    state.newsDetails.updateLoading = false;

    // Ažuriraj i u osnovnoj listi ako postoji
    if (state.news.data.length > 0) {
      state.news.data = state.news.data.map((news) =>
        news.id === updatedData.id ? { ...news, ...updatedData } : news
      );
    }
  });
  builder.addCase(updateNewsDetails.rejected, (state, action) => {
    state.newsDetails.updateLoading = false;
    state.newsDetails.error = action.payload || action.error.message;
  });
};

export const createNewsDetailsBuilder = (builder) => {
  builder.addCase(createNewsDetails.pending, (state) => {
    state.newsDetails.createLoading = true;
    state.newsDetails.error = null;
  });
  builder.addCase(createNewsDetails.fulfilled, (state, { payload }) => {
    const newData = payload.data || payload;
    state.newsDetails.data = newData;
    state.newsDetails.createLoading = false;

    // Dodaj u osnovnu listu
    if (state.news.data) {
      state.news.data = [newData, ...state.news.data];
    }
  });
  builder.addCase(createNewsDetails.rejected, (state, action) => {
    state.newsDetails.createLoading = false;
    state.newsDetails.error = action.payload || action.error.message;
  });
};

// Za javni prikaz
export const getNewsPublicDetailsBuilder = (builder) => {
  builder.addCase(getNewsPublicDetails.pending, (state) => {
    state.publicNewsDetails.loading = true;
    state.publicNewsDetails.error = null;
  });
  builder.addCase(getNewsPublicDetails.fulfilled, (state, { payload }) => {
    state.publicNewsDetails.data = payload.data || payload;
    state.publicNewsDetails.loading = false;
  });
  builder.addCase(getNewsPublicDetails.rejected, (state, action) => {
    state.publicNewsDetails.loading = false;
    state.publicNewsDetails.error = action.payload || action.error.message;
  });
};
